import * as z from "zod";

/** Clears whatever discount the merchant's active cart holds. */
export const removeSuppliesDiscount = {
  name: "removeSuppliesDiscount" as const,
  input: z.object({}),
  output: z.object({}),
};
